import { FlightStatus } from '@connect-x-app/shared-domain-models';

import { RequestOptions } from '../../queries';

export type QueryParameters = {
  direction?: 'after' | 'before';
  filter?: {
    status?: FlightStatus;
    workstationId?: string;
  };
  pagination?: {
    anchorId?: string;
    include?: boolean;
    limit?: string;
    offset?: string;
  };
  query?: string;
  sort?: {
    direction: 'asc' | 'desc';
    field: string;
  };
};

export const parseRequestOptionsToUrlParams = <T extends object>(options?: RequestOptions<T>): QueryParameters => {
  const params: QueryParameters = {};

  if (options?.limit !== undefined) {
    params.pagination = params.pagination ?? {};
    params.pagination.limit = String(options.limit);
  }

  if (options?.offset !== undefined) {
    params.pagination = params.pagination ?? {};
    params.pagination.offset = String(options.offset);
  }

  if (options?.sort && options.sort.length > 0) {
    const sortString = options.sort[0].parse() as string;
    const [field, direction] = sortString.split(':');
    params.sort = {
      direction: direction as 'asc' | 'desc',
      field,
    };
  }

  return params;
};
